define('modules/overview/view_player_loop_modal',[
  'backbone',
  'jquery',
  '_',
  'moment',
  'modules/video/player/video_player_view',
  'modules/htmlad/player/htmlad_player_view',
  'modules/htmlad/template/htmlad_template_model',
  'text!./view_player_loop_modal_template.html',
  'session'
], function (Backbone, $, _,
  moment,
  VideoPlayer,
  HtmlAdPlayer,
  HtmlAdModel,
  modal_template,
  session) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.currentPlaylistItemIndex = 0;
      this.htmlAdEndedEvent = null;
    },

    hasSidebar: false,

    subViews: [],
    tagName: 'div',
    className: 'view-player-loop-modal',
    template: _.template(modal_template),

    events: {
      'click .js-cancel': 'closeModal',
      'click .js-show-media': 'showSelectedMedia'
    },

    render: function () {

      console.log(this.playlistItems);

      this.$el.html(this.template({
        playlistItems: this.playlistItems
      }));

      this.showMedia();

      return this;
    },

    showMedia: function () {
      if (this.playlistItems.length < 1) {
        return;
      }

      var mediaFormat = this.getMediaFormat();

      if (mediaFormat === 'htmlad') {
        console.log('htmlad');
        var htmlAdPlayer = this.createHtmlAdPlayer();
        this.pushMediaToSubview(htmlAdPlayer);
      }
      else if (mediaFormat === 'video') {
        console.log('video');
        var videoPlayer = this.createVideoPlayer();
        this.pushMediaToSubview(videoPlayer);
      }
    },

    showSelectedMedia: function (event) {
      clearTimeout(this.htmlAdEndedEvent);
      this.removeActiveMedia(this.currentPlaylistItemIndex);
      this.currentPlaylistItemIndex = parseInt(event.target.dataset.playlistIndex);
      this.addActiveMedia(this.currentPlaylistItemIndex);
      this.showMedia();
    },

    getMediaFormat: function () {
      return this.playlistItems[this.currentPlaylistItemIndex].metadata.format;
    },

    pushMediaToSubview: function (mediaPlayer) {
      this.subViews.push(mediaPlayer);
      this.$('.media-container').html(mediaPlayer.$el);
    },

    createHtmlAdPlayer: function () {
      var model = new HtmlAdModel(this.playlistItems[this.currentPlaylistItemIndex]);
      var timeoutDuration = this.playlistItems[this.currentPlaylistItemIndex].duration * 1000;
      this.htmlAdEndedEvent = setTimeout(this.bindHtmlAdEndedEvent.bind(this), timeoutDuration);
      return new HtmlAdPlayer({ model: model });
    },

    bindHtmlAdEndedEvent: function () {
      this.removeActiveMedia(this.currentPlaylistItemIndex);
      this.currentPlaylistItemIndex = (this.currentPlaylistItemIndex + 1 < this.playlistItems.length) ? this.currentPlaylistItemIndex + 1 : 0;
      this.addActiveMedia(this.currentPlaylistItemIndex);
      this.showMedia();
    },
    
    createVideoPlayer: function () {
      var videoPlayer = new VideoPlayer({
        hide_close_button: true,
        video: {
          preview: this.playlistItems[this.currentPlaylistItemIndex].preview,
          poster: this.playlistItems[this.currentPlaylistItemIndex].poster,
          name: this.playlistItems[this.currentPlaylistItemIndex].name,
        }
      });
      this.bindVideoEndedEvent(videoPlayer);
      return videoPlayer;
    },

    bindVideoEndedEvent: function (videoPlayer) {
      var self = this;
      videoPlayer.$video.on('ended', function () {
        self.removeActiveMedia(self.currentPlaylistItemIndex);
        self.currentPlaylistItemIndex = (self.currentPlaylistItemIndex + 1 < self.playlistItems.length) ? self.currentPlaylistItemIndex + 1 : 0;
        self.addActiveMedia(self.currentPlaylistItemIndex);
        self.showMedia();
      });
    },

    removeActiveMedia: function (id) {
      var mediaEl = document.querySelector('.js-playlist-item-index-' + id);
      mediaEl.classList.remove('active');
    },

    addActiveMedia: function (id) {
      var mediaEl = document.querySelector('.js-playlist-item-index-' + id);
      mediaEl.classList.add('active');
    },

    closeModal: function (e) {
      if (e) {
        e.preventDefault();
      }
      this.trigger('close');
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });

  return View;
});

